import { ApplicationType } from '@shared/enums/application-type.enum';
import {
  TenantConfig,
  TenantRegistry,
} from '@app/core/interfaces/tenant-config.interface';
import { TenantKey } from '@app/core/enums/tenant-key.enum';
import { environment } from '@environments/environment';

export const TENANTS: TenantRegistry = {
  [TenantKey.PROBATE]: {
    key: TenantKey.PROBATE,
    applicationTypes: [ApplicationType.ESTATE],
    environmentConfig: environment.tenants.probate,
    eventNavigationPaths: {
      clerk: {
        fromLogin: 'dashboard/admin',
      },
      subscriber: {
        fromLogin: 'dashboard/applications',
        fromRegister: 'probate/start/will-estate',
        toDashboard: 'probate/dashboard/home',
      },
    },
  },
  [TenantKey.GUARDIANSHIP]: {
    key: TenantKey.GUARDIANSHIP,
    applicationTypes: [ApplicationType.GUARDIANSHIP_CONSERVATORSHIP],
    environmentConfig: environment.tenants.guardianship,
    eventNavigationPaths: {
      clerk: {
        fromLogin: 'dashboard/admin',
      },
      subscriber: {
        fromLogin: 'guardianship/dashboard/applications',
        fromRegister: 'guardianship/start/court-order',
        toDashboard: 'guardianship/dashboard/applications',
      },
    },
  },
  [TenantKey.MINOR]: {
    key: TenantKey.MINOR,
    applicationTypes: [ApplicationType.MINOR_ESTATES],
    environmentConfig: environment.tenants.minor,
    eventNavigationPaths: {
      clerk: {
        fromLogin: 'dashboard/admin',
      },
      subscriber: {
        fromLogin: 'minor/dashboard/applications',
        fromRegister: 'minor/start/preview/relationship-confirmation',
        toDashboard: 'minor/dashboard/applications',
      },
    },
  },
  [TenantKey.TRUST]: {
    key: TenantKey.TRUST,
    applicationTypes: [ApplicationType.TRUST],
    environmentConfig: environment.tenants.trust,
    eventNavigationPaths: {
      clerk: {
        fromLogin: 'dashboard/admin',
      },
      subscriber: {
        fromLogin: 'trust/dashboard/applications',
        fromRegister: 'trust/start/trust-information',
        toDashboard: 'trust/dashboard/applications',
      },
    },
  },
} satisfies TenantRegistry;

export const getTenantConfig = (key: TenantKey): TenantConfig => TENANTS[key];
